export const ConsumTypes = {
    Parcel: "PARCEL",
    Machinery: "UTILAJ",
    UnitateEconomica: "UNITATE_ECONOMICA",
    Works: "WORKS",
};

export const ParcelSelectionTypes = {
    Map: "map",
    List: "list",
};

export const ConsumOptions = [
    {
        code: ConsumTypes.Parcel,
        titleKey: "stock_management.consum.options.parcel",
    },
    {
        code: ConsumTypes.Works,
        titleKey: "stock_management.consum.options.works",
    },
    {
        code: ConsumTypes.Machinery,
        titleKey: "stock_management.consum.options.machinery",
    },
    {
        code: ConsumTypes.UnitateEconomica,
        titleKey: "stock_management.consum.options.economic_unit",
    },
];

export const ParcelSelectionOptions = [
    {
        code: ParcelSelectionTypes.Map,
        titleKey: "stock_management.consum.parcel_selection.map",
    },
    {
        code: ParcelSelectionTypes.List,
        titleKey: "stock_management.consum.parcel_selection.list",
    },
];

